import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useState } from "react";

export const useAuthStatus = () => {
  const auth = getAuth();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isExternal, setIsExternal] = useState(false);
  const [authCheckComplete, setAuthCheckComplete] = useState(false);

  useEffect(() => {
    const checkSignInMethod = async (user: User | null) => {
      if (!user) {
        setIsSignedIn(false);
        setIsExternal(false);
      } else {
        setIsSignedIn(true);
        try {
          const idTokenResult = await user.getIdTokenResult();
          setIsExternal(idTokenResult.signInProvider === "custom");
        } catch (error) {
          console.error("Error getting ID token result:", error);
        }
      }
      setAuthCheckComplete(true);
    };

    const unsubscribe = onAuthStateChanged(auth, checkSignInMethod);

    return () => unsubscribe();
  }, [auth]);

  return { isSignedIn, isExternal, authCheckComplete };
};
